import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import {
  GET_COMMUNICATION_CONTACTS,
  ADD_COMMUNITY,
  EDIT_COMMUNICATION_CONTACTS,
  GET_COMMUNICATION_PREFERENCES,
  UPDATE_COMMUNICATION_PREFERENCES,
  GET_COMMUNICATION_ADDRESS,
  UPDATE_COMMUNICATION_ADDRESS,
  EMAIL_TO_CUSTOMER,
  GET_BILLING_HISTORY_LIST,
  GET_COMMUNITIES_LIST,
  DELETE_COMMUNITY,
} from "../../../../Urls.js";

const initialState = {
  communitiesLIst: { data: [], loader: false },
  createContactsData: { data: {}, loader: false, successMessage: "" },
  editContactsData: { data: {}, loader: false, successMessage: "" },
  selectedContactData: { data: {} },
  selectedMesage: {},
  communicationList: { data: [], loader: false },
  updateCommunicationData: { data: {}, loader: false, successMessage: "" },
  getAddressData: { data: {}, loader: false, successMessage: "" },
  updateAddressData: { data: {}, loader: false, successMessage: "" },
  emsilToCustomer: { data: {}, loader: false },
};

export const getsignedCommunitiesList = createAsyncThunk(
  "app/getsignedCommunitiesList",
  async (payload) => {
    const response = await axios.get(GET_COMMUNITIES_LIST, {
      params: {
        pageNumber: payload?.pageNumber || 1,
        pageSize: payload?.pageSize || 50,
      },
    });
    // console.log("response",response)
    return response;
  }
);

export const deleteCommunity = createAsyncThunk(
  "app/delete/deleteCommunity",
  async (payload) => {
    const response = await axios.delete(DELETE_COMMUNITY + payload.id);
    return response;
  }
);

export const addCommunity = createAsyncThunk(
  "app/post/addCommunity",
  async (data) => {
    const response = await axios.post(ADD_COMMUNITY, { ...data });
    return response;
  }
);
export const updateExistingCommunity = createAsyncThunk(
  "app/put/updateExistingCommunity",
  async (data) => {
    const response = await axios.put(ADD_COMMUNITY + "/" + data?.id, {
      ...data,
    });
    return response;
  }
);

export const getCommunicationPreferences = createAsyncThunk(
  "app/get/getCommunicationPreferences",
  async (crm_service_account_id) => {
    const resMessageList = await axios.get(
      GET_COMMUNICATION_PREFERENCES + crm_service_account_id
    );
    return resMessageList;
  }
);
export const getCommunicationAddress = createAsyncThunk(
  "app/get/getCommunicationAddress",
  async (crm_service_account_id) => {
    const resMessageList = await axios.get(
      GET_COMMUNICATION_ADDRESS + crm_service_account_id
    );
    return resMessageList;
  }
);

export const updateCommunicationPreferences = createAsyncThunk(
  "app/get/updateCommunicationPreferences",
  async (data) => {
    const response = await axios.post(UPDATE_COMMUNICATION_PREFERENCES, data);
    return response;
  }
);
export const updateCommunicationAddress = createAsyncThunk(
  "app/get/updateCommunicationAddress",
  async (data) => {
    const response = await axios.post(
      UPDATE_COMMUNICATION_ADDRESS + data.billing_group_id,
      data
    );
    return response;
  }
);

export const sentMailtoCustomer = createAsyncThunk(
  "app/post/sendMailToCustomer",
  async (data) => {
    const response = await axios.post(EMAIL_TO_CUSTOMER, { ...data });
    return response;
  }
);

export const signedCommunitiesSlice = createSlice({
  name: "app/signedCommunities",
  initialState,
  reducers: {
    selectedMesage: (state, action) => {
      state.selectedMesage = action?.payload;
    },
    clearSuccessMessage: (state) => {
      state.createContactsData.successMessage = "";
      state.editContactsData.successMessage = "";
    },
    clearSuccessMessageCommunication: (state) => {
      state.updateCommunicationData.successMessage = "";
    },
    clearAddressDatamessage: (state) => {
      state.updateAddressData.successMessage = "";
    },
    setSelectedContact: (state, action) => {
      state.selectedContactData = action?.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(addCommunity.pending, (state) => {
        state.createContactsData.loader = true;
      })
      .addCase(addCommunity.fulfilled, (state, action) => {
        state.createContactsData.loader = false;
        state.createContactsData.data = action?.payload?.data?.data;
        state.createContactsData.successMessage =
          "Contact details added successfully!";
      })
      .addCase(addCommunity.rejected, (state) => {
        state.createContactsData.loader = false;
        state.createContactsData.data = {};
        state.createContactsData.successMessage =
          "Failed to add Contact details!";
      })
      .addCase(updateExistingCommunity.pending, (state) => {
        state.editContactsData.loader = true;
      })
      .addCase(updateExistingCommunity.fulfilled, (state, action) => {
        state.editContactsData.loader = false;
        state.editContactsData.data = action?.payload?.data?.data;
        state.editContactsData.successMessage =
          "Contact details updated successfully!";
      })
      .addCase(updateExistingCommunity.rejected, (state) => {
        state.editContactsData.loader = false;
        state.editContactsData.data = {};
        state.editContactsData.successMessage =
          "Failed to update Contact details!";
      })

      .addCase(getCommunicationPreferences.pending, (state) => {
        state.communicationList.loader = true;
      })
      .addCase(getCommunicationPreferences.fulfilled, (state, action) => {
        state.communicationList.loader = false;
        state.communicationList.data = action?.payload?.data?.data;
      })
      .addCase(getCommunicationPreferences.rejected, (state) => {
        state.communicationList.loader = false;
      })
      .addCase(updateCommunicationPreferences.pending, (state) => {
        state.updateCommunicationData.loader = true;
      })
      .addCase(updateCommunicationPreferences.fulfilled, (state, action) => {
        state.updateCommunicationData.loader = false;
        state.updateCommunicationData.data = action?.payload?.data?.data;
        state.updateCommunicationData.successMessage =
          "Communication preferences updated successfully!";
      })
      .addCase(updateCommunicationPreferences.rejected, (state) => {
        state.updateCommunicationData.loader = false;
        state.updateCommunicationData.data = {};
        state.updateCommunicationData.successMessage =
          "Failed to update Communication preferences!";
      })
      .addCase(updateCommunicationAddress.pending, (state) => {
        state.updateAddressData.loader = true;
      })
      .addCase(updateCommunicationAddress.fulfilled, (state, action) => {
        state.updateAddressData.loader = false;
        state.updateAddressData.data = action?.payload?.data;
        state.updateAddressData.successMessage =
          "Communication Address updated successfully!";
      })
      .addCase(updateCommunicationAddress.rejected, (state) => {
        state.updateAddressData.loader = false;
        state.updateAddressData.data = {};
        state.updateAddressData.successMessage =
          "Failed to update Communication Address!";
      })

      //email to customer
      .addCase(sentMailtoCustomer.pending, (state) => {
        state.emsilToCustomer.loader = true;
      })
      .addCase(sentMailtoCustomer.fulfilled, (state, action) => {
        state.emsilToCustomer.loader = false;
        state.emsilToCustomer.data = action?.payload?.data?.data;
      })
      .addCase(sentMailtoCustomer.rejected, (state) => {
        state.emsilToCustomer.loader = false;
      })

      .addCase(getCommunicationAddress.pending, (state) => {
        state.getAddressData.loader = true;
      })
      .addCase(getCommunicationAddress.fulfilled, (state, action) => {
        state.getAddressData.loader = false;
        state.getAddressData.data = action?.payload?.data?.data;
      })
      .addCase(getCommunicationAddress.rejected, (state) => {
        state.getAddressData.loader = false;
      });
  },
});

export const {
  selectedMesage,
  clearSuccessMessage,
  clearSuccessMessageCommunication,
  setSelectedContact,
  clearAddressDatamessage,
} = signedCommunitiesSlice.actions;

export default signedCommunitiesSlice.reducer;
